(() => {
  const warningElement = document.querySelector('[data-prop-65-warning]');
  if (!warningElement) return;

  const cachedState = localStorage.getItem('prop65_location_state');
  const cachedTimestamp = localStorage.getItem('prop65_location_timestamp');
  const cacheExpiry = 24 * 60 * 60 * 1000;

  if (cachedState && cachedTimestamp) {
    if (Date.now() - parseInt(cachedTimestamp) < cacheExpiry) {
      if (cachedState === 'CA') warningElement.style.display = '';
      return;
    }
  }

  function isCaliforniaState(state) {
    if (!state) return false;
    const s = state.toUpperCase();
    return s === 'CA' || s === 'CALIFORNIA';
  }

  function handleLocationResult(state) {
    const isCA = isCaliforniaState(state);
    localStorage.setItem('prop65_location_state', isCA ? 'CA' : (state || 'unknown'));
    localStorage.setItem('prop65_location_timestamp', Date.now().toString());
    if (isCA) warningElement.style.display = '';
  }

  fetch('https://get.geojs.io/v1/ip/geo.json')
    .then(r => { if (!r.ok) throw new Error(); return r.json(); })
    .then(data => handleLocationResult(data.region))
    .catch(() =>
      fetch('https://ipapi.co/json/')
        .then(r => { if (!r.ok) throw new Error(); return r.json(); })
        .then(data => handleLocationResult(data.region_code || data.region))
        .catch(() => { warningElement.style.display = ''; })
    );
})();
